import { useState } from "react";
import { toast } from "sonner";
import { EnvelopeSimple, Check } from "@phosphor-icons/react";
import api from "@/lib/api";

export const EmailPlanForm = ({ weekStart, planId }) => {
  const [open, setOpen] = useState(false);
  const [to, setTo] = useState("");
  const [message, setMessage] = useState("");
  const [state, setState] = useState("idle");

  const send = async (e) => {
    e.preventDefault();
    setState("sending");
    try {
      await api.post("/meal-plan/share-email", { week_start: weekStart, to: to.trim(), message, ...(planId ? { plan_id: planId } : {}) });
      setState("sent");
      toast.success(`Meal plan emailed to ${to.trim()}`);
      setTimeout(() => { setState("idle"); setTo(""); setMessage(""); setOpen(false); }, 1500);
    } catch (err) {
      setState("idle");
      toast.error(err?.response?.data?.detail || "Couldn't send email");
    }
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="btn-outline-ink !py-2 !px-3 text-sm inline-flex items-center gap-2"
        data-testid="planner-share-email"
      >
        <EnvelopeSimple size={16} /> Email this week
      </button>
    );
  }

  return (
    <form onSubmit={send} className="w-full rounded-xl border border-rf-ink/15 bg-rf-cream-alt p-3 space-y-2" data-testid="planner-share-email-form">
      <input
        type="email" required value={to} onChange={(e) => setTo(e.target.value)} autoFocus
        placeholder="Their email address" aria-label="Recipient email"
        className="input-rf w-full" data-testid="planner-share-email-to"
      />
      <textarea
        value={message} onChange={(e) => setMessage(e.target.value)} maxLength={500} rows={2}
        placeholder="Add a message (optional)" aria-label="Optional message"
        className="input-rf w-full resize-none" data-testid="planner-share-email-message"
      />
      <div className="flex justify-end gap-2">
        <button type="button" onClick={() => setOpen(false)} className="btn-outline-ink !py-1.5 !px-3 text-sm" data-testid="planner-share-email-cancel">Cancel</button>
        <button
          type="submit" disabled={state !== "idle"}
          className={`btn-orange !py-1.5 !px-4 text-sm inline-flex items-center gap-1.5 ${state === "sent" ? "!bg-emerald-600 !text-white" : ""}`}
          data-testid="planner-share-email-send"
        >
          {state === "sent" ? <><Check size={14} weight="bold" /> Sent</> : state === "sending" ? "Sending…" : "Send"}
        </button>
      </div>
    </form>
  );
};
